import restaurantBasicPlan from '@/assets/formats/restaurant-basic-plan'
import beautyBasicPlan from '@/assets/formats/beauty-basic-plan'
import blankBasicPlan from '@/assets/formats/blank-basic-plan'

const planIndex = {
  restaurant: {
    title: '例文入りの事業計画書(飲食店)',
    desc: '飲食店の例文入りテンプレートです。',
    basicPlan: restaurantBasicPlan,
    spreadSheetsKindName: 'restaurant'
  },
  beauty: {
    title: '例文入りの事業計画書(エステサロン)',
    desc: 'エステサロンの例文入りテンプレートです。',
    basicPlan: beautyBasicPlan,
    spreadSheetsKindName: 'beauty'
  },
  blank: {
    title: '白紙の事業計画書',
    desc: '例文の入っていないテンプレートです。',
    basicPlan: blankBasicPlan,
    spreadSheetsKindName: 'restaurant'
  }
}

export default planIndex
